"use strict";

import axios from "@/plugins/axios";


export const news = {
    namespaced: true,
    state: {
        news: []
    },
    getters: {
        getNews: (state) => state.news
    },
    mutations: {
        UPDATE_NEWS: (state, payload) => { state.news = payload }
    },
    actions: {
        async createNews({ state }, payload) {
            try {
                let res = (await axios.post("/api/news", payload)).data;
                 
                window.flash({ type: res.success ? "success" : "error", msg: res.message })
                if (res.success) {state.news.unshift(res.data); return true}
                else return false;
            } catch (e) {
                return e
                 
            }
        },
        async delete({ state }, payload) {
            try {
                 
                let res = (await axios.delete(`/api/news`, { params: { id: payload.id } })).data;
                 
                if (res.success) state.news.splice(state.news.findIndex(n => n._id === payload.id), 1)
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                 
                return error
            }
        },
        async getNews({ commit }) {
            try {
                let res = (await axios.get("/api/news")).data;
                 
                if (res.success){
                    commit("UPDATE_NEWS", res.data);}
            } catch (e) {
                 
                return e
            }
        },
       
    }
}